/**
 * Wishlist Hero: don't open the wishlist popup while an add/remove is still being saved.
 *
 * On a visitor's first add, the app makes two requests in a row (create the wishlist, then add the item).
 * Opening the popup reloads the list from the app's server, so if it's opened before those finish
 * (easy on a phone's slower connection), it shows "no items" while the header count says 1.
 * This holds the header-icon click until pending saves are done, then replays it.
 */
(function () {
  const APP_HOST = 'wishlist-hero.revampco.com';
  // After a heart tap the app takes a moment before its save request starts; treat that time as "saving" too.
  const TAP_GRACE_MS = 1500;
  const MAX_WAIT_MS = 8000;
  const HEART_SELECTOR = '.wishlist-hero-custom-button, [class*="wishlisthero-"] button, .wishlist-hero-product-page-button';
  const HEADER_SELECTOR = 'a[href="#hero-wishlist"]';

  let pending = 0;
  let graceUntil = 0;

  function isAppSave(method, url) {
    return String(url).includes(APP_HOST) && String(method || 'GET').toUpperCase() !== 'GET';
  }

  function onSaveStart() {
    pending++;
    // The save has started, so the tap grace period is no longer needed
    graceUntil = 0;
  }

  function onSaveEnd() {
    pending = Math.max(0, pending - 1);
  }

  function isBusy() {
    return pending > 0 || Date.now() < graceUntil;
  }

  // The app uses XMLHttpRequest
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__wlhSave = isAppSave(method, url);
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__wlhSave) {
      onSaveStart();
      this.addEventListener('loadend', onSaveEnd, { once: true });
    }
    return originalSend.apply(this, arguments);
  };

  // …and in case a future version switches to fetch
  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : input && input.url;
      const method = (init && init.method) || (input && input.method);
      if (!isAppSave(method, url)) return originalFetch.apply(this, arguments);

      onSaveStart();
      return originalFetch.apply(this, arguments).finally(onSaveEnd);
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      // Heart tapped: a save is about to start
      if (event.target.closest(HEART_SELECTOR) && !event.target.closest(HEADER_SELECTOR)) {
        graceUntil = Date.now() + TAP_GRACE_MS;
        return;
      }

      const icon = event.target.closest(HEADER_SELECTOR);
      if (!icon || icon.__wlhReplaying || !isBusy()) return;

      // Hold this click until saving has finished, then replay it for the app
      event.preventDefault();
      event.stopImmediatePropagation();
      icon.classList.add('is-waiting');

      const startedAt = Date.now();
      (function waitThenOpen() {
        if (isBusy() && Date.now() - startedAt < MAX_WAIT_MS) {
          setTimeout(waitThenOpen, 100);
          return;
        }
        icon.classList.remove('is-waiting');
        icon.__wlhReplaying = true;
        icon.click();
        icon.__wlhReplaying = false;
      })();
    },
    true
  );
})();
